import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function AdministrarRips() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },[]);

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key={'k1'}><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key={'k2'}><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key={'k3'}>Administrador de RIPS</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Administrar RIPS</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                            <div className="row">
                                <div className="col-md-12 btn-settings-container">
                                    
                                    <Link to={"consecutivos-rs"} className="btn-settings">
                                    Configuracion Consecutivos RS
                                    </Link>

                                    {/* ❌ DESCARTADOS v998 - Movidos a otros módulos o eliminados
                                    
                                    <Link to={"parametros-rips"} className="btn-settings">
                                    Configuracion Informe RIPS
                                    </Link>

                                    <Link to={"ciediez"} className="btn-settings">
                                    Administrar Códigos CIE10/CIE11
                                    </Link>

                                    <Link to={"ciediez"} className="btn-settings">
                                    Configuracion Informacion SISPRO
                                    </Link>

                                    <Link to={"cups"} className="btn-settings">
                                    Administrar Codigos CUPS
                                    </Link>
                                    
                                    */}

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default AdministrarRips;